<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="900px"
    top="5vh"
    :close-on-click-modal="false"
    @closed="onClosed"
  >
    <div class="map-container">
      <div class="search-bar">
        <el-select v-model="currentCity" placeholder="选择城市" style="width: 120px;" @change="onCityChange">
          <el-option label="全国" value="全国"></el-option>
          <el-option label="北京市" value="北京市"></el-option>
          <el-option label="上海市" value="上海市"></el-option>
          <el-option label="广州市" value="广州市"></el-option>
          <el-option label="深圳市" value="深圳市"></el-option>
        </el-select>
        <el-input
          v-model="keyword"
          placeholder="搜索地址"
          style="width: 200px; margin-left: 10px;"
          @keyup.enter.native="searchLocation"
        >
          <i slot="prefix" class="el-icon-search"></i>
        </el-input>
        <el-button type="primary" @click="searchLocation" style="margin-left: 10px;">
          搜索
        </el-button>
      </div>

      <div class="map-wrapper">
        <div id="tencent-map-container" class="map-canvas"></div>
        <div class="map-tip" v-if="!selectedLocation">
          <i class="el-icon-location-information"></i>
          点击地图选择位置，或搜索后选择
        </div>
      </div>

      <div class="result-list" v-if="searchResults.length > 0">
        <div
          v-for="(item, index) in searchResults"
          :key="index"
          class="result-item"
          @click="selectSearchResult(item)"
        >
          <div class="result-name">{{ item.title }}</div>
          <div class="result-address">{{ item.address }}</div>
        </div>
      </div>

      <div class="selected-info" v-if="selectedLocation">
        <el-icon class="el-icon-location-information" style="color: #409eff;"></el-icon>
        <span>已选位置：{{ selectedLocation.address }}</span>
        <span class="coord">({{ selectedLocation.lat.toFixed(6) }}, {{ selectedLocation.lng.toFixed(6) }})</span>
      </div>
    </div>

    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="confirmLocation" :disabled="!selectedLocation">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
/* global TMap */
const MAP_KEY = 'JJLBZ-BQHYG-YK5QF-QYADS-ARWOE-ICBOQ'

export default {
  name: 'LocationPicker',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '选择位置'
    },
    center: {
      type: Object,
      default: () => ({ lat: 30.572816, lng: 114.27719 })
    }
  },
  data() {
    return {
      dialogVisible: false,
      keyword: '',
      map: null,
      marker: null,
      selectedLocation: null,
      searchResults: [],
      defaultCenter: null,
      currentCity: '全国',
      currentCityCode: '',
      ipLocationDone: false
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.$nextTick(() => {
          this.initMap()
          if (!this.ipLocationDone) {
            this.getIpLocation()
          }
        })
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  created() {
    this.getBrowserLocation()
  },
  methods: {
    // 获取浏览器 GPS 定位
    getBrowserLocation() {
      if (!navigator.geolocation) return

      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.defaultCenter = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
        },
        (err) => {
          console.warn('获取位置失败:', err.message)
        },
        { timeout: 10000 }
      )
    },
    // 获取 IP 定位
    getIpLocation() {
      const url = `https://apis.map.qq.com/ws/location/v1/ip?key=${MAP_KEY}&output=jsonp&cb=JSONP_CALLBACK`
      this.jsonpRequest(url).then((data) => {
        if (data && data.status === 0 && data.result) {
          this.ipLocationDone = true
          this.defaultCenter = {
            lat: data.result.location.lat,
            lng: data.result.location.lng
          }
          this.currentCity = data.result.ad_info.city || '全国'
          this.currentCityCode = data.result.ad_info.cityid || ''

          // 更新地图中心
          if (this.map) {
            this.map.setCenter(new TMap.LatLng(this.defaultCenter.lat, this.defaultCenter.lng))
            // 添加默认标记
            this.addMarker(this.defaultCenter.lat, this.defaultCenter.lng)
            // 默认选中当前位置
            this.selectLocation(this.defaultCenter.lat, this.defaultCenter.lng)
          }
        }
      }).catch((err) => {
        console.error('IP定位失败:', err)
        this.searchNearby()
      })
    },
    // 搜索附近地址
    searchNearby() {
      if (!this.defaultCenter) return

      const url = `https://apis.map.qq.com/ws/place/v1/search?keyword=建筑&boundary=region(${this.currentCity},0)&page_size=20&key=${MAP_KEY}&output=jsonp&cb=JSONP_CALLBACK`

      this.jsonpRequest(url).then((data) => {
        if (data && data.data && data.data.length > 0) {
          this.searchResults = data.data.map(item => ({
            title: item.title,
            address: item.address,
            lat: item.location.lat,
            lng: item.location.lng
          }))
        } else if (data && data.cluster && data.cluster.length > 0) {
          // 附近没有数据，显示城市分类
          this.searchResults = data.cluster.map(item => ({
            title: item.title,
            address: '包含 ' + item.count + ' 个结果',
            lat: null,
            lng: null,
            isCluster: true
          }))
        }
      }).catch((err) => {
        console.error('搜索附近地址失败:', err)
      })
    },
    initMap() {
      if (this.map) return

      setTimeout(() => {
        const container = document.getElementById('tencent-map-container')
        if (!container) {
          setTimeout(() => this.initMap(), 100)
          return
        }

        if (typeof TMap === 'undefined') {
          console.error('腾讯地图 TMap API 未加载')
          this.$message.error('地图加载失败，请刷新页面重试')
          return
        }

        const centerLat = this.defaultCenter?.lat || this.center.lat || 30.572816
        const centerLng = this.defaultCenter?.lng || this.center.lng || 114.27719

        this.map = new TMap.Map(container, {
          center: new TMap.LatLng(centerLat, centerLng),
          zoom: 15,
          mapStyleId: 'style1'
        })

        this.map.on('click', (evt) => {
          this.selectLocation(evt.latLng.lat, evt.latLng.lng)
        })

        // 地图初始化完成后，选中当前位置
        if (this.defaultCenter && this.defaultCenter.lat) {
          this.addMarker(this.defaultCenter.lat, this.defaultCenter.lng)
          this.selectLocation(this.defaultCenter.lat, this.defaultCenter.lng)
        }
      }, 100)
    },
    // 使用 REST API 搜索地址
    searchLocation() {
      if (!this.keyword) {
        this.$message.warning('请输入搜索关键字')
        return
      }

      const boundary = this.currentCityCode
        ? `boundary=region(${this.currentCity},${this.currentCityCode},0)`
        : `boundary=region(${this.currentCity},0)`
      const url = `https://apis.map.qq.com/ws/place/v1/search?keyword=${encodeURIComponent(this.keyword)}&${boundary}&page_size=20&key=${MAP_KEY}&output=jsonp&cb=JSONP_CALLBACK`

      // 使用 jsonp 方式请求
      this.jsonpRequest(url).then((data) => {
        if (data && data.data && data.data.length > 0) {
          this.searchResults = data.data.map(item => ({
            title: item.title,
            address: item.address,
            lat: item.location.lat,
            lng: item.location.lng
          }))
        } else if (data && data.cluster && data.cluster.length > 0) {
          // 没有精确结果，显示城市分类建议
          this.searchResults = data.cluster.map(item => ({
            title: item.title,
            address: '包含 ' + item.count + ' 个结果，点击查看',
            lat: null,
            lng: null,
            isCluster: true
          }))
        } else {
          this.$message.warning('未找到相关地址')
        }
      }).catch((err) => {
        console.error('搜索失败:', err)
        this.$message.error('搜索失败，请重试')
      })
    },
    // JSONP 请求封装
    jsonpRequest(url) {
      return new Promise((resolve, reject) => {
        const callbackName = 'jsonp_' + Date.now()
        const script = document.createElement('script')
        script.src = url.replace('JSONP_CALLBACK', callbackName)
        window[callbackName] = (data) => {
          resolve(data)
          delete window[callbackName]
          document.body.removeChild(script)
        }
        script.onerror = (err) => {
          reject(err)
          delete window[callbackName]
          if (script.parentNode) document.body.removeChild(script)
        }
        document.body.appendChild(script)
      })
    },
    // 城市切换时清空搜索结果
    onCityChange() {
      this.searchResults = []
      this.keyword = ''
    },
    selectSearchResult(item) {
      if (item.isCluster) {
        // 点击城市分类，用城市名重新搜索
        this.keyword = item.title
        this.searchLocation()
        return
      }
      this.selectLocation(item.lat, item.lng)
      if (this.map) {
        this.map.setCenter(new TMap.LatLng(item.lat, item.lng))
      }
    },
    selectLocation(lat, lng) {
      this.selectedLocation = {
        lat,
        lng,
        address: '正在获取地址...'
      }

      // 使用 REST API 逆地址解析
      const url = `https://apis.map.qq.com/ws/geocoder/v1/?location=${lat},${lng}&key=${MAP_KEY}&get_poi=1&output=jsonp&cb=JSONP_CALLBACK`

      this.jsonpRequest(url).then((data) => {
        if (data && data.result) {
          // 获取省市区信息
          const ad = data.result.ad_info || {}
          const region = (ad.province || '') + (ad.city || '') + (ad.district || '')
          
          // 获取详细地址
          const recommend = data.result.formatted_addresses?.recommend || ''
          const rough = data.result.formatted_addresses?.rough || ''
          const addr = data.result.address || ''
          
          // 优先使用 recommend，但加上省市区前缀
          if (recommend) {
            // recommend 可能已经包含省市区，检查是否已包含
            const hasRegion = recommend.includes(ad.province || '') && recommend.includes(ad.district || '')
            this.selectedLocation.address = hasRegion ? recommend : region + recommend
          } else if (rough) {
            this.selectedLocation.address = region + rough
          } else {
            this.selectedLocation.address = region + addr || '未知地址'
          }
          
          // 更新当前城市
          if (ad.city) {
            this.currentCity = ad.city
            this.currentCityCode = ad.cityid || this.currentCityCode
          }
        } else {
          this.selectedLocation.address = '未知地址'
        }
      }).catch(() => {
        this.selectedLocation.address = '未知地址'
      })

      this.updateMarker(lat, lng)
      // 搜索当前点附近地址
      this.searchNearbyByPoint(lat, lng)
    },
    // 根据坐标搜索附近地址
    searchNearbyByPoint(lat, lng) {
      // 使用 geocoder 的 get_poi 参数获取附近地址
      const url = `https://apis.map.qq.com/ws/geocoder/v1/?location=${lat},${lng}&key=${MAP_KEY}&get_poi=1&poi_options=page_size=20;page_index=1&output=jsonp&cb=JSONP_CALLBACK`

      this.jsonpRequest(url).then((data) => {
        if (data && data.result && data.result.pois && data.result.pois.length > 0) {
          this.searchResults = data.result.pois.map(item => ({
            title: item.title,
            address: item.address,
            lat: item.location.lat,
            lng: item.location.lng
          }))
        }
      }).catch((err) => {
        console.error('搜索附近地址失败:', err)
      })
    },
    // 计算两点之间的距离（米）
    getDistance(lat1, lng1, lat2, lng2) {
      const R = 6371000
      const dLat = (lat2 - lat1) * Math.PI / 180
      const dLng = (lng2 - lng1) * Math.PI / 180
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                Math.sin(dLng / 2) * Math.sin(dLng / 2)
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      return R * c
    },
    updateMarker(lat, lng) {
      if (this.marker) {
        this.marker.setMap(null)
      }

      // 使用内联 SVG 作为标记图标
      const svgIcon = 'data:image/svg+xml;base64,' + btoa(`
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 30 40">
          <path d="M15 0C6.716 0 0 6.716 0 15c0 10.5 15 25 15 25s15-14.5 15-25C30 6.716 23.284 0 15 0z" fill="#e53e3e"/>
          <circle cx="15" cy="15" r="6" fill="white"/>
        </svg>
      `)

      this.marker = new TMap.MultiMarker({
        map: this.map,
        styles: {
          marker: new TMap.MarkerStyle({
            width: 30,
            height: 40,
            anchor: { x: 15, y: 40 },
            src: svgIcon
          })
        },
        geometries: [{
          id: 'marker',
          styleId: 'marker',
          position: new TMap.LatLng(lat, lng)
        }]
      })
    },
    confirmLocation() {
      if (this.selectedLocation) {
        let fullAddress = this.selectedLocation.address
        if (this.selectedLocation.addressDetail) {
          fullAddress = fullAddress + this.selectedLocation.addressDetail
        }
        this.$emit('select', {
          address: fullAddress,
          latitude: this.selectedLocation.lat,
          longitude: this.selectedLocation.lng
        })
        this.dialogVisible = false
      }
    },
    onClosed() {
      this.keyword = ''
      this.selectedLocation = null
      this.searchResults = []
    }
  },
  beforeDestroy() {
    if (this.map) {
      this.map.destroy()
      this.map = null
    }
  }
}
</script>

<style scoped>
.map-container {
  height: 600px;
}

.search-bar {
  margin-bottom: 15px;
}

.map-wrapper {
  position: relative;
  height: 280px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
}

.map-canvas {
  width: 100%;
  height: 100%;
}

.map-tip {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.9);
  padding: 10px 20px;
  border-radius: 4px;
  color: #909399;
  font-size: 14px;
  pointer-events: none;
}

.result-list {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #dcdfe6;
  border-top: none;
  border-radius: 0 0 4px 4px;
  margin-top: -1px;
}

.result-item {
  padding: 10px 15px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
}

.result-item:last-child {
  border-bottom: none;
}

.result-item:hover {
  background: #f5f7fa;
}

.result-name {
  font-size: 14px;
  color: #303133;
  margin-bottom: 4px;
}

.result-address {
  font-size: 12px;
  color: #909399;
}

.selected-info {
  margin-top: 15px;
  padding: 12px 15px;
  background: #f0f9eb;
  border: 1px solid #e1f3d8;
  border-radius: 4px;
  color: #67c23a;
  font-size: 14px;
}

.selected-info .coord {
  margin-left: 10px;
  color: #909399;
  font-size: 12px;
}
</style>
